import { DataflytContactPhone, DataflytContactEmail } from 'components/dataflyt-contact';
import React from 'react';
import { Alert } from 'antd';
import { useLocation } from 'react-router-dom';

/** Callers can request departure instructions without identifying the source page. */
export default function PobDepartureGuidance() {
    const { search } = useLocation();
    if (new URLSearchParams(search).get('guidance') !== 'depart-pob') return null;

    return <Alert
        type="info"
        banner
        className="mc-qm-departure-guidance"
        showIcon
        message="Depart the POB record before removing the person"
        description={<>
            <ol>
                <li>Find the highlighted <strong>Target record</strong> in <strong>Departing Passengers</strong> and select its checkbox.</li>
                <li>Click <strong>Depart</strong> and confirm. This changes their check-in type to <strong>DEPARTED</strong>.</li>
                <li>Return to the person deletion dialog and refresh the preview.</li>
            </ol>
            <p>Select the individual person to avoid departing everyone in the displayed list.</p>
            <p>If they are still Expected or Onboard, use the external Quartermaster product to move them into Departing.
                Moving between columns is not available on this screen. Alternatively, contact Dataflyt at{' '}
                <DataflytContactPhone /> or{' '}
                <DataflytContactEmail /> for assistance.</p>
        </>}
    />;
}
